"use client";

import Link from "next/link";

function Product({ product }) {
  return (
    <Link prefetch={false} href={product?.product_url || "#"}>
      <div className="jlt-mt-8 jlt-flex jlt-items-center jlt-gap-4">
        <img
          src={product?.product_image?.url}
          alt={product?.productImage?.alt || "Product Logo"}
          width={48}
          height={48}
        />
        <span className="jlt-text-lg jlt-text-[#667085] jlt-font-bold hover:jlt-text-[#475467] jlt-transition-all jlt-duration-200">
          {product?.product_name}
        </span>
      </div>
    </Link>
  );
}

export default Product;
